
import { IBotbuilderMessage } from './botbuilder';

import {
  RecognizerType,
  RecognizerScope,
  IInteractionBase,
  Bot,
  Workspace
} from './model';

export enum RecognizerProvider {
  kissbot = 'kissbot',
  dialogflow = 'dialogflow',
  watson = 'watson'
}

export interface IAttribute {
  type: string;
  name: string;
  value: any;
}

export interface IEntity {
  type: string;
  name: string;
  value: any;
  startIndex?: number;
  endIndex?: number;
  score?: number;
}

export interface IRecognizerResult<T extends IInteractionBase> {
  recognizer?: string;
  source?: string;
  type?: RecognizerType;
  provider?: RecognizerProvider;
  interaction?: T;
  responseStep?: number;
  elementStep?: number;
  score: number;
  entities?: IEntity[];
  options?: any;
  index?: number;
}

export interface IInteractionContext<T extends IInteractionBase> {
  path: string[],
  lastInteractionId: string;
  interaction?: T;
  interactionId: string;
  responseStep: number;
  elementStep: number;
  recognizerScope: RecognizerScope,
  lastMessage: IMessage;
  data: any;
  lifespan?: number;
}

export interface IConversationFlowChanged<T extends IInteractionBase> {
  bot?: Bot,
  workspace?: Workspace,
  index: number,
  fromInteraction?: T,
  toInteraction: T,
  conversationId?: string,
  activityId?: string,
  incoming?: IMessage
}

export interface IEvent {
  type: string;
  name?: string;
}

export interface IMessage extends IBotbuilderMessage {
  event?: IEvent;
}
